// Don't offer AI generation on fields too short to hold a decent greeting.
// MIN_FIELD_MAXLENGTH is the smallest qualifying maxlength; an unbounded field
// (maxlength absent → -1/0) always qualifies. Applies to every field, including
// captions (see attach() in index.ts) — a caption capped at 30-50 chars is too
// short for AI-generated text to be useful.
export const MIN_FIELD_MAXLENGTH = 51;

export function fieldAllowsTrigger(maxLength: number): boolean {
    return maxLength <= 0 || maxLength >= MIN_FIELD_MAXLENGTH;
}

// Below this короткое/среднее/длинное are 45/65/85% of one sentence: on the
// prevailing 65-char field that is 29/42/55 chars, a choice without a
// difference. From 150 up the tiers are 68/98/128 — a line vs two or three.
export const MIN_MAXLENGTH_FOR_LENGTH_CHOICE = 150;

export const fieldOffersLengthChoice = (maxLength: number): boolean =>
    maxLength <= 0 || maxLength >= MIN_MAXLENGTH_FOR_LENGTH_CHOICE;

/**
 * Write generated text into the card-content textarea and notify listeners.
 *
 * `maxlength` only constrains typed input, NOT a programmatic `.value =`, so we
 * clamp to it ourselves — otherwise an over-budget generation would land in the
 * field and fail/silently truncate at submit. The `input`/`change` events drive the
 * form's char counter, max-length message and any draft-save logic.
 */
export function insertGeneratedText(
    field: HTMLTextAreaElement | HTMLInputElement,
    text: string
): void {
    const max = field.maxLength; // -1 when the attribute is absent
    field.value = max > 0 ? text.slice(0, max) : text;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
    field.focus();
}
